import React from 'react';
import { EstimateForm, MaterialType } from '../types';
import { MATERIAL_SPECS, getMaterialSpec } from '../utils/materialSpecs';

interface InputPanelProps {
  form: EstimateForm;
  onChange: (form: EstimateForm) => void;
  onGenerate: () => void;
}

const InputPanel: React.FC<InputPanelProps> = ({ form, onChange, onGenerate }) => {
  const handleChange = (field: keyof EstimateForm, value: string | number) => {
    onChange({ ...form, [field]: value });
  };
  // 재질 변경 시 현재 두께가 그 재질에 없으면 첫 번째 가능 두께로
  const handleMaterialChange = (material: MaterialType) => {
    const { thicknesses } = getMaterialSpec(material);
    const thick = thicknesses.includes(form.PANEL_THICK) ? form.PANEL_THICK : thicknesses[0];
    onChange({ ...form, MATERIAL: material, PANEL_THICK: thick });
  };

  return (
    <div className="pd-card">
      <h2 className="pd-title">도면 설정</h2>

      <div className="pd-row">
        <div>
          <label className="pd-label">재질</label>
          <select value={form.MATERIAL} onChange={e => handleMaterialChange(e.target.value as MaterialType)} className="pd-input">
            {(Object.keys(MATERIAL_SPECS) as MaterialType[]).map(m => (
              <option key={m} value={m}>{MATERIAL_SPECS[m].label}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="pd-label">두께</label>
          <select value={form.PANEL_THICK} onChange={e => handleChange('PANEL_THICK', Number(e.target.value))} className="pd-input">
            {getMaterialSpec(form.MATERIAL).thicknesses.map(t => (
              <option key={t} value={t}>{t}T</option>
            ))}
          </select>
        </div>
      </div>

      <div className="pd-row">
        <div>
          <label className="pd-label">가로 (mm)</label>
          <input type="number" value={form.HORIZONTAL || ''} onChange={e => handleChange('HORIZONTAL', Number(e.target.value))} className="pd-input" placeholder="5000" />
        </div>
        <div>
          <label className="pd-label">세로 (mm)</label>
          <input type="number" value={form.VERTICAL || ''} onChange={e => handleChange('VERTICAL', Number(e.target.value))} className="pd-input" placeholder="3000" />
        </div>
      </div>

      <div className="pd-row">
        <div>
          <label className="pd-label">높이 (mm)</label>
          <input type="number" value={form.HEIGHT || ''} onChange={e => handleChange('HEIGHT', Number(e.target.value))} className="pd-input" placeholder="2400" />
        </div>
        <div>
          <label className="pd-label">벽고 (mm)</label>
          <input type="number" value={form.WALL_HEIGHT || ''} onChange={e => handleChange('WALL_HEIGHT', Number(e.target.value))} className="pd-input" placeholder="2400" />
        </div>
      </div>

      <div className="pd-row">
        <div>
          <label className="pd-label">천장</label>
          <select value={form.CEILING_YN} onChange={e => handleChange('CEILING_YN', e.target.value)} className="pd-input">
            <option value="N">없음</option>
            <option value="Y">있음</option>
          </select>
        </div>
        {form.CEILING_YN === 'Y' && (
          <div>
            <label className="pd-label">천장방향</label>
            <select value={form.CEILING_HV} onChange={e => handleChange('CEILING_HV', e.target.value)} className="pd-input">
              <option value="H">가로</option>
              <option value="V">세로</option>
            </select>
          </div>
        )}
      </div>

      <div className="pd-row">
        <div>
          <label className="pd-label">바닥</label>
          <select value={form.FLOOR_YN} onChange={e => handleChange('FLOOR_YN', e.target.value)} className="pd-input">
            <option value="N">없음</option>
            <option value="Y">있음</option>
          </select>
        </div>
      </div>

      <button onClick={onGenerate} className="pd-btn primary block" style={{ marginTop: 4 }}>도면 생성</button>
    </div>
  );
};


export default InputPanel;
